import { combineReducers } from 'redux'
import { formReducer, modelReducer } from 'react-redux-form'

import * as h2Api from '../../h2Api'
import * as actions from '../../actions/admin/dataLoaderActions'
import { initialEditForm } from '../../actions/profileCommon'

const loaderForm = {
  file: {},
  year: 2020
}

export default combineReducers({
  loaderRequest: h2Api.restReducer(actions.LOADER_REQUEST),
  loaderForm: modelReducer('admin.loader.loaderForm', loaderForm),
  forms: formReducer('admin.loader', { loaderForm })
})
